// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray);
var foldlWithIndex = /* #__PURE__ */ Data_FoldableWithIndex.foldlWithIndex(Foreign_Object.foldableWithIndexObject);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var FromJSONKeyString = /* #__PURE__ */ (function () {
    function FromJSONKeyString(value0) {
        this.value0 = value0;
    };
    FromJSONKeyString.create = function (value0) {
        return new FromJSONKeyString(value0);
    };
    return FromJSONKeyString;
})();
var FromJSONKeyValue = /* #__PURE__ */ (function () {
    function FromJSONKeyValue(value0) {
        this.value0 = value0;
    };
    FromJSONKeyValue.create = function (value0) {
        return new FromJSONKeyValue(value0);
    };
    return FromJSONKeyValue;
})();
var fromJSONKeyString = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new FromJSONKeyString(Control_Category.identity(Control_Category.categoryFn))
    };
})();
var decodeUnit = {
    unsafeDecode: function (v) {
        return Data_Unit.unit;
    }
};
var decodeString1 = {
    unsafeDecode: $foreign.decodeString
};
var decodeRecordNil = {
    recordInfo: function (v) {
        return $foreign.recordInfoNil;
    }
};
var decodeNumber1 = {
    unsafeDecode: $foreign.decodeNumber
};
var decodeInt1 = {
    unsafeDecode: $foreign.decodeInt
};
var decodeForeign = {
    unsafeDecode: function (x) {
        return x;
    }
};
var decodeBoolean1 = {
    unsafeDecode: $foreign.decodeBoolean
};
var unsafeDecode = function (dict) {
    return dict.unsafeDecode;
};
var decodeArray1 = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeArray(unsafeDecode(dictDecode))
    };
};
var decodeMaybe = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return {
        unsafeDecode: function (value) {
            var $82 = Foreign.isNull(value) || Foreign.isUndefined(value);
            if ($82) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(unsafeDecode2(value));
        }
    };
};
var decodeNonEmptyArray = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return {
        unsafeDecode: function (f) {
            var v = Data_Array_NonEmpty.fromArray($foreign.decodeArray(unsafeDecode2)(f));
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return $foreign.decodingError("NonEmptyArray should not be empty");
            };
            throw new Error("Failed pattern match at Unscramble (line 63, column 5 - line 67, column 58): " + [ v.constructor.name ]);
        }
    };
};
var decodeObject1 = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeObject(unsafeDecode(dictDecode))
    };
};
var decodeSet = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (dictOrd) {
        return {
            unsafeDecode: (function () {
                var $96 = fromFoldable(dictOrd);
                var $97 = $foreign.decodeArray(unsafeDecode2);
                return function ($98) {
                    return $96($97($98));
                };
            })()
        };
    };
};
var decodeTuple = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (dictDecode1) {
        var unsafeDecode3 = unsafeDecode(dictDecode1);
        return {
            unsafeDecode: function (v) {
                var v1 = $foreign.expectArray(v);
                if (v1.length === 2) {
                    return new Data_Tuple.Tuple(unsafeDecode2(v1[0]), unsafeDecode3(v1[1]));
                };
                return $foreign.decodingError("Invalid array length in Tuple representation");
            }
        };
    };
};
var unsafeDecode1 = /* #__PURE__ */ unsafeDecode(/* #__PURE__ */ decodeArray1(/* #__PURE__ */ decodeTuple(decodeForeign)(decodeForeign)));
var recordInfo = function (dict) {
    return dict.recordInfo;
};
var decodeRecord1 = function () {
    return function (dictDecodeRecord) {
        return {
            unsafeDecode: $foreign.decodeRecord(recordInfo(dictDecodeRecord)(Type_Proxy["Proxy"].value))
        };
    };
};
var decodeRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictDecode) {
        var unsafeDecode2 = unsafeDecode(dictDecode);
        return function (dictDecodeRecord) {
            var recordInfo1 = recordInfo(dictDecodeRecord);
            return {
                recordInfo: function (v) {
                    return $foreign.recordInfoCons(reflectSymbol(Type_Proxy["Proxy"].value))(unsafeDecode2)(recordInfo1(Type_Proxy["Proxy"].value));
                }
            };
        };
    };
};
var fromJSONKey = function (dict) {
    return dict.fromJSONKey;
};
var decodeMap = function (dictFromJSONKey) {
    var fromJSONKey1 = fromJSONKey(dictFromJSONKey);
    return function (dictOrd) {
        var insert = Data_Map_Internal.insert(dictOrd);
        return function (dictDecode) {
            var unsafeDecode2 = unsafeDecode(dictDecode);
            return {
                unsafeDecode: function (v) {
                    if (fromJSONKey1 instanceof FromJSONKeyString) {
                        return foldlWithIndex(function (k) {
                            return function (acc) {
                                return function (v2) {
                                    return insert(fromJSONKey1.value0(k))(unsafeDecode2(v2))(acc);
                                };
                            };
                        })(Data_Map_Internal.empty)($foreign.expectObject(v));
                    };
                    if (fromJSONKey1 instanceof FromJSONKeyValue) {
                        return foldl(function (acc) {
                            return function (v2) {
                                return insert(fromJSONKey1.value0(v2.value0))(unsafeDecode2(v2.value1))(acc);
                            };
                        })(Data_Map_Internal.empty)(unsafeDecode1(v));
                    };
                    throw new Error("Failed pattern match at Unscramble (line 106, column 5 - line 110, column 142): " + [ fromJSONKey1.constructor.name ]);
                }
            };
        };
    };
};
var defaultFromJSONKeyValue = function (dictDecode) {
    return new FromJSONKeyValue(unsafeDecode(dictDecode));
};
var catchDecodingErrorEither = /* #__PURE__ */ (function () {
    return $foreign.catchDecodingErrorImpl(Data_Either.Left.create)(Data_Either.Right.create);
})();
var decodeEither = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode2(value);
        });
    };
};
var decodeJSONEither = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode2($foreign.unsafeParseJSON(value));
        });
    };
};
var catchDecodingError = /* #__PURE__ */ (function () {
    return $foreign.catchDecodingErrorImpl(function (v) {
        return Data_Maybe.Nothing.value;
    })(Data_Maybe.Just.create);
})();
var decode = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode2(value);
        });
    };
};
var decodeJSON = function (dictDecode) {
    var unsafeDecode2 = unsafeDecode(dictDecode);
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode2($foreign.unsafeParseJSON(value));
        });
    };
};
export {
    decodingError,
    recordInfoNil,
    recordInfoCons,
    decodeRecord,
    isString,
    decodeString,
    isNumber,
    decodeNumber,
    decodeInt,
    decodeBoolean,
    decodeArray,
    decodeObject,
    expectObject,
    expectArray,
    unsafeParseJSON,
    catchDecodingErrorImpl
} from "./foreign.js";
export {
    fromJSONKey,
    recordInfo,
    unsafeDecode,
    decode,
    decodeEither,
    decodeJSON,
    decodeJSONEither,
    defaultFromJSONKeyValue,
    FromJSONKeyString,
    FromJSONKeyValue,
    catchDecodingError,
    catchDecodingErrorEither,
    decodeForeign,
    decodeUnit,
    decodeString1,
    decodeNumber1,
    decodeInt1,
    decodeBoolean1,
    decodeArray1,
    decodeNonEmptyArray,
    decodeTuple,
    decodeObject1,
    decodeRecord1,
    decodeMaybe,
    decodeSet,
    fromJSONKeyString,
    decodeMap,
    decodeRecordNil,
    decodeRecordCons
};
